import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { AppState } from 'src';
import { GeneralInfoComponent, GeneralInfoComponentProperties } from './general-info.component';

import FormNames from '@constants/FormNames.enum';
import { VendorViewModel } from '../../../../../_models/Vendor';
import { saveFormData } from '../../../../vendor.actions';
import { searchVendors, clearVendorSearch } from 'src/vendor/_components/vendor-dashboard/vendor-dashboard.actions';
import { ModalProps } from '@common/components';
import { toggleModal } from '@common/components/common.actions';
import { actions } from 'react-redux-form';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: {
    buttonRef: (button: HTMLButtonElement) => void;
    next: Function;
    currentStep: number;
    isEdit: boolean;
  }
): Partial<GeneralInfoComponentProperties> {
  return {
    vendorVM: state.vendor.vendorVM,
    buttonRef: ownProps.buttonRef,
    vendorSearchResults: state.vendorMaintenance.searchResults,
    vendorSearchPageCount: state.vendorMaintenance.searchPageCount,
    isEdit: ownProps.isEdit
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: {
    buttonRef: (button: HTMLButtonElement) => void;
    currentStep: number;
    next?: Function;
    isEdit: boolean;
  }
): Partial<GeneralInfoComponentProperties> {
  return {
    onSaveClick: (model: VendorViewModel, validator: any, isEdit?: boolean) => {
      actions.submit(
        FormNames.VendorGeneralInfo,
        new Promise(async resolve => {
          const isValid = isEdit ? true : await validator(model);
          if (isValid) {
            dispatch(saveFormData(model));
            if (ownProps.next) {
              ownProps.next();
            }
            resolve(true);
          }
        })
      );
    },
    searchVendors: (query, pageSize, pageNumber, orderBy, orderDirection) => {
      return dispatch(searchVendors(query, pageSize, pageNumber, orderBy, orderDirection));
    },
    toggleModal: (props?: ModalProps) => {
      dispatch(toggleModal(props));
    },
    clearVendors: () => {
      dispatch(clearVendorSearch());
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const GeneralInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralInfoComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/steps/general-info/general-info.container.ts